import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.132 4c1.023 0 2.047.391 2.828 1.17201 1.562 1.56202 1.562 4.09506 0 5.65709l-3.5361 3.535c-.781.781-1.804 1.172-2.828 1.172-1.024 0-2.047-.391-2.82803-1.172l1.41403-1.414c.378.378.88.586 1.414.586.534 0 1.036-.208 1.414-.586l3.5361-3.53503c.78-.78001.78-2.04903 0-2.82904-.378-.378-.88-.58601-1.414-.58601-.5351 0-1.0371.20801-1.4151.58601l-.952.95301c-.701-.335-1.463-.531-2.256-.573l1.794-1.79403C14.0839 4.391 15.1079 4 16.132 4z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41357 17.5469l.95303-.953c.701.335 1.463.53 2.256.573l-1.794 1.794c-.782.781-1.80504 1.171-2.82905 1.171s-2.04703-.39-2.82804-1.171c-1.56201-1.562-1.56201-4.0951 0-5.6571l3.53505-3.53603c.78101-.78101 1.80504-1.17101 2.82904-1.17101 1.023 0 2.047.39 2.828 1.17101l-1.414 1.41503c-.378-.378-.88-.586-1.414-.586-.535 0-1.037.208-1.415.586l-3.53507 3.535c-.78001.78-.78001 2.0491 0 2.8291.37801.377.88001.585 1.41402.585.53401 0 1.03701-.208 1.41402-.585z",
    fill: "currentColor"
  }));
});